import React from 'react'

import './CoBrandLogo.component.scss'

const CoBrandLogo = ({ agentLogo, agentLogoAlt, partnerLogo, layout = 'inline' }) => (
  <span className={`cobrand-logo cobrand-logo--${layout}`}>
    <img className='cobrand-agent' alt={agentLogoAlt} src={agentLogo} />
    <span className='cobrand-partner'>
      <span className='cobrand-label'>In partnership with</span>
      <img className='cobrand-usabg' alt='USA Benefits Group' src={partnerLogo} />
    </span>
  </span>
)

export default CoBrandLogo
